const IGNORED_WORDS = new Set(['a', 'an', 'the', 'of', 'and']);

export function getTextLogoInitials(name: string, max = 3): string {
  const words = String(name || '')
    .replace(/[^\p{L}\p{N}\s-]/gu, ' ')
    .trim()
    .split(/[\s-]+/)
    .filter(Boolean)
    .filter((word) => !IGNORED_WORDS.has(word.toLowerCase()));

  if (!words.length) return '?';
  if (words.length === 1) return words[0].slice(0, max).toUpperCase();
  if (words.length === 2 && words[0].length === 2) return words[0].toUpperCase();
  return words.slice(0, max).map((word) => word[0]).join('').toUpperCase();
}

export function getTextLogoName(name: string): string {
  return String(name || '').trim() || 'Trade-Proof';
}
